import { useLocaleForControl } from "../../../../lib/locale/useLocaleForControl";
import { FileUploaderLocaleHelper } from "../../../../components/FileUploader/locale";
export var useControlLocale = function useControlLocale() {
  return useLocaleForControl('FileUploader', FileUploaderLocaleHelper);
};